import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Icon, Container, Row, Col } from '@polichat/flamboyant';
import { IconLabelContainer, HorizontalRule } from './ChannelDescriptionBanner.styles';
import { IconPlusIcon } from '../../../../assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export default function ChannelBaseboardInstagramRefactor({ isConnected, namePage }) {
  const history = useHistory();
  
  // Traduções
  const connectInstagramAccount = useGlotaT('spa.certification.connectInstagramAccount');
  const instagramConnectionRedirect = useGlotaT('spa.certification.instagramConnectionRedirect');
  const instagramAlreadyAuthorized = useGlotaT('spa.certification.instagramAlreadyAuthorized');
  const connectNow = useGlotaT('spa.certification.connectNow');
  const selectPage = useGlotaT('spa.certification.selectPage');
  const instagramPageLinked = useGlotaT('spa.certification.instagramPageLinked');

  const isConnectedBool = !!isConnected;

  const renderInstagramRow = () => {
    return (
      <Row>
        <Col lg="3" className="my-2 d-flex justify-content-center justify-content-lg-end">
          <IconLabelContainer>
            <IconPlusIcon 
              firstIcon="onlyLogo"
              secondIcon="poli-icon pi-instagram-fill"
              secondColor="#ff647c"
            />
          </IconLabelContainer>
        </Col>
        <Col lg="6" className="my-2 text-center">
          {isConnectedBool
            ? instagramAlreadyAuthorized
            : instagramConnectionRedirect}
        </Col>
        <Col lg="3" className="my-2 d-flex justify-content-center justify-content-lg-start">
          {!isConnectedBool ? (
            <Button color="primary" onClick={() => history.push('/tools/channels/add')}>
              <span>{connectNow}</span>
            </Button>
          ) : (
            <Button color="primary" disabled>
              <span>{connectNow}</span>
            </Button>
          )}
        </Col>
      </Row>
    );
  };

  return (
    <>
      <div style={{ marginTop: '45px' }}>{connectInstagramAccount}</div>
      <HorizontalRule />
      <Container fluid="true">
        {renderInstagramRow()}
      </Container>
      <HorizontalRule />
      {isConnectedBool && (
        <>
          <div style={{ marginTop: '45px' }}>{selectPage}</div>
          <HorizontalRule />
          <Container fluid="true">
            <Row>
              <Col lg="3" className="my-2 d-flex justify-content-center justify-content-lg-end">
                <IconLabelContainer>
                  <IconPlusIcon 
                    firstIcon="onlyLogo"
                    secondIcon="poli-icon pi-instagram-fill"
                    secondColor="#ff647c"
                  />
                </IconLabelContainer>
              </Col>
              <Col lg="6" className="my-2 text-center">
                {instagramPageLinked} "{namePage}"
              </Col>
              <Col lg="3" className="my-2 d-flex justify-content-center justify-content-lg-start"></Col>
            </Row>
          </Container>
          <HorizontalRule />
        </>
      )}
    </>
  );
}